/**
 * Epic 80431 (Pooja Pujara on 80430, 2026-10-16): the sidebar badge polls only every 5 minutes, so
 * it refreshes straight after the user's own action - start, submit, approve, complete a task,
 * close - which is when the number actually changes. The workflow service announces those; the
 * badge hook listens. A window event keeps the two apart: the service needs no React, and the
 * hook needs no knowledge of every screen that can change the count.
 */
export const WORKFLOW_COUNT_CHANGED_EVENT = "workflow:count-changed";

export const notifyWorkflowCountChanged = (): void => {
  window.dispatchEvent(new Event(WORKFLOW_COUNT_CHANGED_EVENT));
};
